import { combineReducers } from "redux";
import adminReducer from "./admin-reducer";
import associateReducer from "./associate-reducer";

export default combineReducers({
    MT_ADMIN_STORE: adminReducer,
    MT_ASSOCIATE_STORE: associateReducer
})